module.exports = __webpack_public_path__ + "static/magmin-2b9b24c020bff76dd41e9788133b4ccb.jpeg";